import { render } from "./StrainDetail.vue?vue&type=template&id=2d5632ee&scoped=true"
import script from "./StrainDetail.vue?vue&type=script&lang=js"
export * from "./StrainDetail.vue?vue&type=script&lang=js"

import "./StrainDetail.vue?vue&type=style&index=0&id=2d5632ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5632ee"]])

export default __exports__